<script>
    import GPickr from "./gpickr/gpickr";
    import { Button } from "sveltestrap";
    import { onMount, tick } from "svelte";
    import store from "../store";
    import { _log } from "../utils/logger";
    import { deleteGradients, getAllGradient, putGradients } from "../db";
    import l from "../utils/locale";
    import AppIconDraw from "../AppIconDraw.svelte";

    let isOpen = false;

    export let id = "stroke";
    let gpickr;
    let boxGBtnEl;
    let boxGEl;
    let isActive = false;
    let customGradients = [];
    let currentGradient = { id: -1, css: "" };
    let gradientsArr = [
        {
            id: 1,
            css: `linear-gradient(45deg,rgba(82, 11, 67, 1) 0%,rgba(255, 0, 0, 1) 100%)`,
        },
        {
            id: 2,
            css: `radial-gradient(circle at center,rgba(82, 11, 67, 1) 0%,rgba(255, 0, 0, 1) 100%)`,
        },
        {
            id: 3,
            css: `linear-gradient(45deg,rgba(53, 115, 19, 1) 0%,rgba(0, 255, 179, 1) 100%)`,
        },
        {
            id: 4,
            css: `radial-gradient(circle at center,rgba(53, 115, 19, 1) 0%,rgba(0, 255, 179, 1) 100%)`,
        },
        {
            id: 5,
            css: `linear-gradient(45deg,rgba(19, 49, 115, 1) 0%,rgba(59, 108, 214, 1) 100%)`,
        },
        {
            id: 6,
            css: `radial-gradient(circle at center,rgba(19, 49, 115, 1) 0%,rgba(59, 108, 214, 1) 100%)`,
        },
        {
            id: 7,
            css: `linear-gradient(45deg,rgba(20, 20, 20, 1) 0%,rgba(220, 220, 220, 1) 100%)`,
        },
        {
            id: 8,
            css: `radial-gradient(circle at center,rgba(20, 20, 20, 1) 0%,rgba(220, 220, 220, 1) 100%)`,
        },
    ];

    const onClickHandler = (e) => {
        const classList = Array.from(e.target.parentNode.classList);
        _log("onClickHandler", classList);
        if (
            !classList.some(
                (v) =>
                    v.startsWith("gpcr-") ||
                    v.startsWith("pcr-") ||
                    v.startsWith("delete-icon") ||
                    v.startsWith("ionicon") ||
                    v.startsWith("save-btn") ||
                    v.startsWith("btn-add-gradient")
            )
        ) {
            isOpen = false;
        }
    };
    $: if (isOpen) {
        _log("addEventListener");
        setTimeout(() => {
            window.addEventListener("click", onClickHandler);
        }, 0);
    }
    $: if (!isOpen) {
        _log("removeEventListener");
        window.removeEventListener("click", onClickHandler);
    }

    function onChangeHandler(instance) {
        const g = instance.getGradient();
        const gradient = parseGradient(g);
        saveToStoreGradient({ ...gradient });
        window.fabricHelper.selectLastActiveObject();
        _log("gpickr", gradient);
        _log("gpickr", boxGBtnEl, this, instance);
        if (boxGBtnEl) {
            boxGBtnEl.style.background = currentGradient.css;
        } else {
            const boxGBtn = document.getElementById("boxGBtn");
            if (boxGBtn) boxGBtn.style.background = currentGradient.css;
        }
    }

    onMount(async () => {
        customGradients = await getAllGradient();
        gpickr = new GPickr({
            el: `.gradient-pickr-${id}`,

            // Pre-defined stops. These are the default since at least two should be defined
            stops: [
                ["rgb(255,132,109)", 0],
                ["rgb(82, 11, 67)", 1],
            ],
        });
        gpickr.on("change", onChangeHandler);
        const unsubscribe = store.subscribe((s) => {
            if (id === "stroke" && s.strokeGradient) {
                currentGradient = s.strokeGradient;
            } else if (id === "fill" && s.fillGradient) {
                currentGradient = s.fillGradient;
            } else if (id === "frame" && s.fillGradientFrame) {
                currentGradient = s.fillGradientFrame;
            }
            _log(
                "subscribe",
                id,
                currentGradient,
                s.strokeGradient,
                s.fillGradient
            );

            isActive =
                (id === "fill" && s.currentFill === "gradient") ||
                (id === "stroke" && s.currentStroke === "gradient") ||
                (id === "drawColor" && s.currentFill === "gradient") ||
                (id === "drawStrokeColor" && s.currentStroke === "gradient");
            _log("isActive", id, s.currentFill, s.currentStroke, isActive);
        });
        return () => {
            _log("Clean GradientSettings");
            gpickr.off("change", onChangeHandler);
            unsubscribe();
        };
    });

    function saveToStoreGradient(gradient) {
        _log("saveToStoreGradient", id, gradient);
        if (id === "stroke") {
            store.setValues({
                currentStroke: "gradient",
                strokeGradient: gradient,
                drawStrokeColor: "rgba(0, 0, 0, 0)",
                strokePattern: { src: "", name: "" },
            });
            window.fabricHelper.updateActive("color_stroke");
        } else if (id === "fill") {
            store.setValues({
                currentFill: "gradient",
                fillGradient: gradient,
                drawColor: "rgba(0, 0, 0, 0)",
                fillPattern: { src: "", name: "" },
            });
            window.fabricHelper.updateActive("color_fill");
        } else if (id === "frame") {
            store.setValues({
                fillGradientFrame: gradient,
                drawColorFrame: "rgba(0, 0, 0, 0)",
                fillPatternFrame: { src: "", name: "" },
            });
        }
        window.fabricHelper.updateActive();
    }

    function parseGradient(g) {
        const gradient = {
            type: "linear",
            css: g,
        };
        const gSplitted = g.split("rgba(");
        gSplitted.shift();

        const colorStops = [];

        gradient.type = g.substring(0, g.indexOf("-"));
        let _angle = 0;
        if (gradient.type === "radial") {
            gradient.angle = g.substring(g.indexOf("(") + 1, g.indexOf(","));
        } else {
            _angle = g
                .substring(g.indexOf("(") + 1, g.indexOf(","))
                .replace("deg", "");
            gradient.angle = parseInt(_angle, 10);
        }
        for (const item of gSplitted) {
            const color = item.substring(0, item.indexOf(")"));
            _log("gpickr color", color);

            const stopStr = item
                .substring(item.lastIndexOf(" "), item.length)
                .replace("%", "")
                .replace(")", "");
            const stop = parseInt(stopStr, 10) / 100;
            _log("gpickr stop", stop);
            colorStops.push({
                color: `rgba(${color})`,
                offset: stop,
            });
        }
        if (gradient.type === "radial" && colorStops.length > 1) {
            const first = colorStops[0];
            const second = colorStops[1];
            const _fc = first.color;
            first.color = second.color;
            second.color = _fc;
        }
        gradient.colorStops = colorStops;

        return gradient;
    }

    function onClickGradientHandler(e) {
        const _id = e.target.id;
        const g = gradientsArr.find((g) => _id === `gradient${g.id}`);
        _log("onClickGradientHandler", g);
        gpickr.setGradient(g.css);
        const gradient = parseGradient(g.css);
        saveToStoreGradient(gradient);
        //currentGradient = gradient;
    }

    function onClickGradientCustomHandler(g) {
        // const id = e.target.id;
        // const g = customGradients.find((g) => id === `gradient${g.id}`);
        // _log("onClickGradientCustomHandler", g);
        gpickr.setGradient(g.css);
        const gradient = parseGradient(g.css);
        saveToStoreGradient(gradient);
        //currentGradient = gradient;
        //customGradients = [...customGradients];
        isOpen = false
    }

    function onClickAddGradient() {
        _log("onClickAddGradient", id, currentGradient);
        putGradients(currentGradient);
        customGradients = [currentGradient, ...customGradients];
    }

    async function deleteGradientHandler(e, id) {

        const result = await deleteGradients(id);
        if (result) {
            customGradients = customGradients.filter((v) => v.id !== id);
        }
    }

    async function toggleBox() {
        isOpen = !isOpen;
        if (isOpen) {
            await tick();
            const rect = boxGBtnEl.getBoundingClientRect();
            if(window.innerHeight <= 400){
                boxGEl.style.top = "0px";
            } else {
                boxGEl.style.top = `${rect.top - rect.height - 10}px`;
            }
            boxGEl.style.left = "210px";
        } else {
        }
    }
    let currentImgUrl = "/data/icons/none.png";
</script>

<div
    style={`background-size: contain; background-position: center; background-image:url(/data/icons/none.png)`}
    id="boxGBtn"
    class:activeColor={isActive}
    bind:this={boxGBtnEl}
    on:click={toggleBox}
/>
<div
    class="boxG"
    bind:this={boxGEl}
    style={`display: ${isOpen ? "block" : "none"}`}
>
    <div class="flex">
        <div class={`gradient-pickr-${id}`} />
        <div class="flex">
            {#each gradientsArr as g}
                <div
                    class:scale={g.css === currentGradient.css}
                    id={`gradient${g.id}`}
                    class={`gradients gradient${g.id}`}
                    on:click={onClickGradientHandler}
                >
                    {#if g.css === currentGradient.css}
                        <div class="checked" on:click>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="ionicon"
                                viewBox="0 0 512 512"
                                ><path
                                    fill="none"
                                    stroke="white"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="32"
                                    d="M416 128L192 384l-96-96"
                                /></svg
                            >
                        </div>
                    {/if}
                </div>
            {/each}
        </div>
    </div>
    <div class="p-2 center save-btn">
        <Button
            color="primary"
            class="btnFlex"
            on:click={onClickAddGradient}
        >
            <AppIconDraw name="add_to_db" />
            {l["add_gradient"]}
        </Button>
    </div>
    <div class="flex">
        {#each customGradients as g}
        <div style="position: relative;"
        class="custom-gradient-item">
            <div
                class="gradients"
                class:scale={g.css === currentGradient.css}
                style={`background: ${g.css}`}
                on:click|stopPropagation={() => onClickGradientCustomHandler(g)}
            >
                {#if g.css === currentGradient.css}
                    <div class="checked" on:click>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="ionicon"
                            viewBox="0 0 512 512"
                            ><path
                                fill="none"
                                stroke="white"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="32"
                                d="M416 128L192 384l-96-96"
                            /></svg
                        >
                    </div>
                {/if}

            </div>
            <div
            class="delete-icon">
            <svg
            on:click|stopPropagation={(e) => deleteGradientHandler(e,g.id)}
                xmlns="http://www.w3.org/2000/svg"
                class="ionicon"
                viewBox="0 0 512 512"
                ><title>{l["remove"]}</title><path
                    d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
                /></svg
            >
        </div>
        </div>
        {/each}
    </div>
</div>

<style>
    #boxGBtn {
        box-shadow: 0 0 2px red inset;
        border-radius: 2px;
        margin-left: 10px;
        margin-top: 1px;
        height: 32px;
        width: 32px;
        padding: 0;
        cursor: pointer;
    }
    .gradient-pickr {
        padding: 10px 0;
    }

    .gradients {
        position: relative;
        margin: 5px;
        cursor: pointer;
        border-radius: 3px;
        width: 45px;
        height: 45px;
    }

    .gradient1 {
        background: linear-gradient(
            45deg,
            rgba(82, 11, 67, 1) 0%,
            rgba(255, 0, 0, 1) 100%
        );
    }
    .gradient2 {
        background: radial-gradient(
            circle at center,
            rgba(82, 11, 67, 1) 0%,
            rgba(255, 0, 0, 1) 100%
        );
    }
    .gradient3 {
        background: linear-gradient(
            45deg,
            rgba(53, 115, 19, 1) 0%,
            rgba(0, 255, 179, 1) 100%
        );
    }
    .gradient4 {
        background: radial-gradient(
            circle at center,
            rgba(53, 115, 19, 1) 0%,
            rgba(0, 255, 179, 1) 100%
        );
    }
    .gradient5 {
        background: linear-gradient(
            45deg,
            rgb(19, 49, 115) 0%,
            rgb(59, 108, 214) 100%
        );
    }
    .gradient6 {
        background: radial-gradient(
            circle at center,
            rgb(19, 49, 115) 0%,
            rgb(59, 108, 214) 100%
        );
    }
    .gradient7 {
        background: linear-gradient(
            45deg,
            rgba(20, 20, 20, 1) 0%,
            rgba(220, 220, 220, 1) 100%
        );
    }
    .gradient8 {
        background: radial-gradient(
            circle at center,
            rgba(20, 20, 20, 1) 0%,
            rgba(220, 220, 220, 1) 100%
        );
    }

    .boxG {
        max-width: 460px;
        position: fixed;
        top: 120;
        left: 60;
        z-index: 989889844343;
        background: white;
        box-shadow: 0 1px 12px var(--main-color);
    }
</style>
